<div class="container">
    <app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>

        <form [formGroup]="settingsForm" (ngSubmit)="onSubmit()">
            <div class="form-group first-div row">
                <div class="col-6 offset-2">
                    <h4>Admin's email: {{adminService.adminSettings.email}} </h4>
                </div>
            </div>

            <div class="form-group row">
                <div class="col-6 offset-2 form-check">
                    <input type="checkbox" [(ngModel)]="prompt" [ngModelOptions]="{standalone: true}" class="form-check-input" id="prompt">
                    <label class="form-check-label text-center">Receive new name notifications</label>
                </div>
            </div>

            <div class="row">
                <div class="col-2"></div>
                <div class="col-6 text-center">
                    <button type="submit" class="btn btn-success btn-lg" [disabled]="disableSubmit">Save</button> <!--!settingsForm.valid didn't work for some reason -->
                    <button type="button" class="btn btn-danger btn-lg" (click)="onCancel()">Cancel</button>
                </div>
            </div>
        </form>
    </div>